<template>
  <div>
    <Head title="Stocktake" />
    <h1 class="mb-4 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/stocktake-reference/${stocktakeRef.id}/edit`">{{ stocktakeTitle }}</Link>
      <span class="text-orange-400 font-medium">/</span> Stocktake
    </h1>

    <div v-if="stocktakeRef.status === 1" class="bg-white rounded-md shadow overflow-hidden mb-5">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-2 -mr-6 p-8">
          <text-input
            v-show="has_quantity === 'yes'"
            v-model="form.quantity"
            :error="form.errors.quantity"
            class="pb-2 pr-6 w-full lg:w-1/2"
            placeholder="Quantity"
          />
          <text-input
            v-model="form.item_id"
            :error="form.errors.item_id"
            class="pb-2 pr-6 w-full lg:w-1/2"
            placeholder="Scan UID"
          />
        </div>
        <div
          class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button
            :loading="form.processing"
            class="btn-orange px-3 py-2 text-xs"
            type="submit"
          >
            Add Count
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import axios from 'axios'

export default {
  components: {
    Head,
    Link,
    TextInput,
    SelectInput,
    LoadingButton,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    stocktakes: Object,
    locations: Object,
    stocktakeRef: Object,
    summationReports: Object,
    stocktakeTitle: String,
    has_quantity: String,
    download_location_id: Number,
    stocktake_ref: Number,
  },
  data() {
    return {
      form: this.$inertia.form({
        item_id: null,
        location: null,
        quantity: null,
      }),
      itemObj: [],
      userSearching: false,
      msgStr: '',
      search: {
        location: this.filters.location
      }
    }
  },
  computed: {
    confirmItem() {
      return this.itemObj || []
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/stocktake-reference/${this.stocktakeRef.id}/stocktakes`, pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    resett() {
      this.search = mapValues(this.search, () => null)
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    store() {
      if (this.msgStr === '') {
        this.form.post(`/stocktake-reference/${this.stocktakeRef.id}/stocktakes`)
        this.form.item_id = ''
        this.itemObj = []
      }
    },
    checkUID() {
      this.userSearching = true
      if (this.form.item_id) {
        axios.get(`/stocktake-inventory-items/${this.stocktakeRef.id}/item/${this.form.item_id}/search`).then(response => {
          if (response.data.message === '') {
            this.itemObj = response.data
            this.msgStr = ''
          } else {
            this.itemObj = []
            this.msgStr = response.data.message
          }
        })
      } else {
        this.msgStr = ''
      }
    },
  },
}
</script>
